import { render, staticRenderFns } from "./VadiguModalAppointment.vue?vue&type=template&id=10ce747a&scoped=true&lang=pug"
import script from "./VadiguModalAppointment.vue?vue&type=script&lang=js"
export * from "./VadiguModalAppointment.vue?vue&type=script&lang=js"
import style0 from "./VadiguModalAppointment.vue?vue&type=style&index=0&id=10ce747a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce747a",
  null
  
)

export default component.exports